import { createRouter, createWebHistory } from 'vue-router'
import IslandDetailView from '@/views/IslandDetailView.vue'
import SearchView from '@/views/SearchView.vue';

// コンポーネント名と実際のコンポーネントオブジェクトをマッピング
const componentMap = {
  'IslandDetail': IslandDetailView,
  'SearchView': SearchView,
};

export const base = '/islands';
//export const base = '';

async function createDynamicRouter() {
  try {
    const response = await fetch(base + '/pub/routes.json');
    if (!response.ok) {
      throw new Error(`Failed to fetch routes: ${response.statusText}`);
    }
    const routesConfig = await response.json();

    // デフォルトルートを追加
    const defaultRoute = {
      path: '/',
      name: '離島検索',
      component: SearchView
    };
    const routes = [
      defaultRoute,
      ...routesConfig.map(route => ({
        path: route.path,
        // name: route.name_en,
        name: route.path.replace(/^\/+/,''),
        component: componentMap[route.component],
        meta: { title: route.name + "｜九州離島図鑑", data: route.data }
      }))
    ];

    const router = createRouter({
      history: createWebHistory(base),
      routes
    });

    router.beforeEach((to, from, next) => {
      document.title = to.meta.title || 'Default Title';
      next();
    });

    return router;
  } catch (error) {
    console.error('Failed to load routes:', error);
    throw error;
  }
}

export default createDynamicRouter;